/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, May 2020
 */

import { Body } from './Body';
import { Headers } from './Headers';

/**
 * An error trhown if a request responds with an error code.
 */
export class HttpError extends Error {
    /**
     * Create an HttpError instance.
     *
     * @param message Error message.
     * @param data Response data.
     */
    constructor(message: string, public readonly data: Body, public readonly httpStatus: number, public readonly headers: Headers) {        super(message);

        if(Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}



// WEBPACK FOOTER //
// ./src/packages/http/lib/HttpError.ts